export default __webpack_public_path__ + "static/PQ-website-logo-e77862e93a2a48ec29427fdb6ea587fa.png";